<template>
    <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20">
        <!-- Header with buttons -->
        <div class="rlms-flex rlms-items-center rlms-justify-between rlms-flex-wrap rlms-gap-10">
            <div class="rlms-fs-lg rlms-fw-600">Groups</div>
        </div>

        <!-- Groups Table or Empty State -->
        <div class="rlms-bg-white rlms-br-20">
            <div v-if="groups.length === 0" class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20 rlms-items-center">
                <div class="rlms-flex rlms-flex-col rlms-gap-desk30-mob-20 rlms-justify-center rlms-items-center"
                    style="min-height: 600px;">
                    <img :src="groupKidsReadingBook" width="300" />
                    <div class="rlms-fw-600 rlms-fs-md">No Group</div>
                    <p style="max-width: 604px;">
                        No record found.
                    </p>
                </div>
            </div>

            <!-- Group list could go here if groups.length > 0 -->
            <div v-else>
                <div class="rlms-table">
                    <div class="rlms-table-inner">
                        <table>
                            <thead>
                                <tr>
                                    <th v-if="userid">Org Name</th>
                                    <th>Groups Name</th>
                                    <th v-if="!userid">Authorized Users</th>
                                    <th v-if="!userid">Learners Count</th>
                                    <th>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="group in groups" :key="group.id">
                                    <td v-if="userid">{{ group?.organization }}</td>
                                    <td>
                                        <label class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-fc rlms-us-none">
                                            <div class="rlms-flex rlms-items-center rlms-gap-10 rlms-w-mc">
                                                <!-- Group avatars -->
                                                <div class="rlms-avatar-group" style="padding-left:23px;">
                                                    <div v-for="i in 3" :key="i" class="rlms-avatar">
                                                        <img :src="noImage" />
                                                    </div>
                                                </div>
                                                <p class="rlms-fw-500">{{ group.name }}</p>
                                            </div>
                                        </label>
                                    </td>
                                    <td v-if="!userid">{{ group.users_count ?? 0 }}</td>
                                    <td v-if="!userid">{{ group.learners_count ?? 0 }}</td>
                                    <td>
                                        <p class="rlms-text-extra-3">{{ formatDate(group.created_at) }}</p>
                                    </td>
                                    <td>
                                        <RouterLink :to="`/admin/organizations/${group?.organization_id}/group/${group.id}`"
                                            class="rlms-flex rlms-items-center rlms-gap-5 rlms-cursor-pointer">
                                            <img :src="eyeIcon" />
                                            <p class="rlms-text-primary-500">View</p>
                                        </RouterLink>
                                    </td>
                                </tr>

                                <tr v-if="groups.length === 0">
                                    <td colspan="5" class="text-center">No groups found.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import api from '@/services/axios';
import { formatDate } from '@/utils/format-helpers';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useLoaderStore } from '@/stores/loader';
import { handleError } from '@/utils/handleError';
import groupKidsReadingBook from '@/assets/images/group-kids-reading-book.png'
import noImage from '@/assets/images/no-image.png'
import eyeIcon from '@/assets/images/eye.svg'

const route = useRoute();
const loader = useLoaderStore();

const organizationId = Number(route.params.organization ?? 0);
const userid = Number(route.params.userid ?? 0);
const groups = ref([]);
const showModal = ref(false);

onMounted(async () => {
    await init();
});

const init = async () => {
    showModal.value = false;
    await fetchData();
}

const fetchData = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/admin/groups`, {
            params: {
                organization_id: organizationId,
                user_id: userid
            }
        });
        groups.value = data.data.groups;
    } catch (error) {
        handleError(error)
    } finally {
        loader.hide();
    }
}
</script>
